import { Icon } from "@iconify/react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { authActions } from "../../store/authSlice";
import { motion } from "framer-motion";

import { NavLink } from "react-router-dom";
import classes from "./Menu.module.css";
import Backdrop from "../../UI/Backdrop/Backdrop";

const variants = {
  open: { opacity: 1, x: 0 },
  closed: { opacity: 0, x: "-100%" },
};

const Menu = () => {
  let content, icon;
  const [visible, setVisible] = useState(false);
  const isLoggedIn = useSelector((state) => state.auth.isAuthenticated);
  const dispatch = useDispatch();

  const visibleHandler = () => {
    setVisible(!visible);
  };

  const logoutHandler = () => {
    setVisible(!visible);
    dispatch(authActions.logout());
  };

  if (isLoggedIn) {
    content = (
      <NavLink
        to="account"
        className={`${classes.link}`}
        onClick={visibleHandler}
      >
        會員中心
      </NavLink>
    );
  } else {
    content = (
      <NavLink
        to="login"
        className={`${classes.link}`}
        onClick={visibleHandler}
      >
        登入
      </NavLink>
    );
  }

  if (!visible) {
    icon = (
      <Icon
        icon="clarity:menu-line"
        color="#363636"
        className={classes.icon}
        onClick={visibleHandler}
        height="30"
        width="30"
      />
    );
  } else {
    icon = (
      <Icon
        icon="ic:baseline-cancel"
        color="#363636"
        className={classes.cancel}
        onClick={visibleHandler}
        height="30"
        width="30"
      />
    );
  }

  return (
    <>
      {icon}
      {visible && (
        <div
          className={classes.backdrop}
          onClick={() => setVisible(!visible)}
        ></div>
      )}
      <div className={`${classes.menu} ${visible ? classes.visible : ""}`}>
        <ul className={classes.menuList}>
          <li>
            <NavLink to="/" className={classes.link} onClick={visibleHandler}>
              首頁
            </NavLink>
          </li>
          <li>
            <NavLink
              to="service"
              className={classes.link}
              onClick={visibleHandler}
            >
              服務
            </NavLink>
          </li>
          <li>
            <NavLink
              to="product"
              className={classes.link}
              onClick={visibleHandler}
            >
              產品
            </NavLink>
          </li>
          <li>
            <NavLink
              to="about"
              className={classes.link}
              onClick={visibleHandler}
            >
              關於
            </NavLink>
          </li>
          <li>
            <NavLink
              to="contact"
              className={classes.link}
              onClick={visibleHandler}
            >
              聯絡
            </NavLink>
          </li>

          <li>{content}</li>
          {isLoggedIn && (
            <li>
              <NavLink to="/" className={classes.link} onClick={logoutHandler}>
                登出
              </NavLink>
            </li>
          )}
        </ul>
      </div>
    </>
  );
};

export default Menu;
